<template>
  <div class="drawer drawer-mobile flex-1 h-full" :class="{ '!block': !isSidebar }">
    <input id="my-drawer" type="checkbox" class="drawer-toggle" />
    <div class="drawer-content flex flex-col items-center !translate-x-0 overflow-y-auto"
      :class="[isSidebar ? 'pt-3 lg:pt-6 pb-3' : '!h-full',isSidebar && routeName != 'cart' ? 'px-2 sm:px-3 lg:px-6' : '']">
      <router-view :key="$route.name + ($route.params?.type || '')" />
    </div>
    <div class="drawer-side overflow-hidden !inline lg:!grid rounded-xl lg:rounded-none" v-if="isSidebar">
      <label for="my-drawer" class="drawer-overlay !row-start-auto lg:hidden"></label>
      <ul :class="backgroundColor"
        class="menu h-full p-4 overflow-y-auto w-full lg:w-64 2xl:w-72 text-base-content grid xl:block grid-cols-3 lg:grid-cols-1 scrollbar-thin scrollbar-thumb-base-300 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-track-base-200">
        <li class="pointer-events-none col-span-full"> <img :src="logo" alt="logo" class="mx-auto my-3 w-36"></li>
        <li class="hidden lg:flex">
          <router-link :to="{ name: 'product' }" class="text-white text-center flex-col lg:flex-row">
            <HomeIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Products') }}
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'profile' }" class="text-white text-center flex-col lg:flex-row">
            <UserIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Profile') }}
          </router-link>
        </li>
        <li class="hidden lg:flex bg-red-custom-2 animate-pulse rounded-lg" v-if="specialTitle">
          <router-link :to="{ name: 'product.special' }" class="text-white text-center flex-col lg:flex-row">
            <PercentBadgeIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ specialTitle }}
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'orders' }" class="text-white text-center flex-col lg:flex-row">
            <ListBulletIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Factors') }}
          </router-link>
        </li>
        <li v-if="featureEnabled('video_training')">
          <router-link :to="{ name: 'video.education' }" class="text-white text-center flex-col lg:flex-row">
            <VideoCameraIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Educational video') }}
          </router-link>
        </li>
        <li v-if="featureEnabled('video_training')">
          <router-link :to="{ name: 'video.application' }" class="text-white text-center flex-col lg:flex-row">
            <VideoCameraIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Application training') }}
          </router-link>
        </li>
        <li><button class="text-white text-center flex-col lg:flex-row" @click="getCategories('intro_brand')">
            <PresentationChartLineIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Introduction of brands') }}
          </button></li>
        <li>
          <router-link :to="{ name: 'product.new' }" class="text-white text-center flex-col lg:flex-row">
            <ClipboardDocumentListIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('New goods') }}
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'product.change' }" class="text-center flex-col lg:flex-row" :class="[featureEnabled('wholesale_price_change') ? 'text-white' : 'pointer-events-none text-gray-300']">
            <ArrowTrendingUpIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Price change') }}
          </router-link>
        </li>
        <li><router-link :to="{ name: 'product.update' }" class="text-white text-center flex-col lg:flex-row">
            <ArrowLeftStartOnRectangleIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Entrance to warehouses') }}
          </router-link></li>
        <li v-if="featureEnabled('lottery')">
          <router-link :to="{ name: 'award' }" class="text-white text-center flex-col lg:flex-row">
            <GiftIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Lottery') }}
          </router-link>
        </li>
        <li v-if="featureEnabled('schedule_sending')">
          <router-link :to="{ name: 'send.order' }" class="text-white text-center flex-col lg:flex-row">
            <ClockIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Delivery schedule') }}
          </router-link>
        </li>
        <li class="hidden lg:flex">
          <router-link :to="{ name: 'notification' }" class="text-white text-center flex-col lg:flex-row">
            <EnvelopeIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Messages') }} <div class="badge badge-error w-5 h-5"
              v-if="user.notification_count > 0">{{ user.notification_count }}</div>
          </router-link>
        </li>
        <li><router-link :to="{ name: 'reserve' }" class="text-white text-center flex-col lg:flex-row">
            <GiftTopIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Reserve goods') }}
          </router-link></li>
          <li class="lg:flex" v-if="featureEnabled('affiliate')"><a
            class="flex-col text-center lg:flex-row pointer-events-none text-gray-300">
            <UserGroupIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Cooperation in sales') }}
          </a></li>
        <li class="lg:flex"><router-link :to="{ name: 'application' }"
            class="text-white flex-col text-center lg:flex-row">
            <Cog6ToothIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Install the application') }}
          </router-link></li>
          <li class="lg:flex"><router-link :to="{ name: 'bug.report' }"
            class="text-white flex-col text-center lg:flex-row">
            <BugAntIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Bug Report') }}
          </router-link></li>
           <li class="lg:flex" v-if="featureEnabled('job_form')"><router-link :to="{ name: 'recruitment.form' }"
            class="text-white flex-col text-center lg:flex-row">
            <BriefcaseIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Recruitment form') }}
          </router-link></li>
        <li><label for="logout" class="text-white text-center flex-col lg:flex-row">
            <ArrowRightStartOnRectangleIcon class="w-9 h-9 lg:h-5 lg:w-5" /> {{ __('Sign out of the user account') }}
          </label></li>
      </ul>

    </div>
  </div>
  <input type="checkbox" id="intro-brand-modal" class="modal-toggle" />
  <label class="modal" v-if="Auth.isSidebar" for="intro-brand-modal">
    <label class="modal-box max-w-5xl" for="">
      <input type="text" :placeholder="__('Search for the desired brand')" @keyup="searchCategory($event, 'brand')"
        class="input w-full bg-blue-custom-1 text-gray-custom-1 placeholder-gray-custom-1" />
      <p class="text-sm mt-3">{{ __('To see the brand introduction, click on its logo') }}</p>
      <div class="card mt-3 bg-base-200 h-56 category md:h-auto">
        <div class="card-body px-2 py-4 md:p-4">
          <div class="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-1 md:gap-5 items-baseline">
            <label class="cursor-pointer hover:bg-gray-100/40 hover:rounded-lg relative" for="introduction-modal"
              v-for="category in brands" @click="introductionBrand = category.description" v-show="!category?.hidden">
              <img :src="category.image" class="w-16 h-16 m-auto" alt="image" />
              <p class="text-center mt-1 text-sm">{{ category.title }}</p>
            </label>
          </div>
          <NotFound v-if="!brands.filter(item => !item.hidden).length" />
        </div>
      </div>
      <div class="modal-action">
        <label class="btn btn-error btn-sm" for="intro-brand-modal">{{ __('Close') }}</label>
      </div>
    </label>
  </label>
  <input type="checkbox" id="introduction-modal" class="modal-toggle" />
  <div class="modal">
    <div class="modal-box max-w-2xl">
      <div v-html="introductionBrand" class="modal-content mce-content-body"></div>
      <div class="modal-action">
        <label class="btn btn-error btn-sm" for="introduction-modal" @click="introductionBrand = null">{{ __('Close') }}</label>
      </div>
    </div>
  </div>
  <input type="checkbox" id="logout" class="modal-toggle" />
  <label class="modal" id="modal-logout" for="logout">
    <label class="modal-box" for="">
      <h3 class="font-bold text-lg">{{ __('Sign out of the account') }}</h3>
      <p class="py-4">{{ __('Are you logging out of your account?') }}</p>
      <div class="modal-action">
        <label class="btn btn-primary btn-sm" for="logout">{{ __('Cancel') }}</label>
        <label class="btn btn-error btn-sm" @click="logout" for="logout">{{ __('Logout') }}</label>
      </div>
    </label>
  </label>

  <div class="modal" id="modal-message" :class="{ 'modal-open': user.privacy_confirm && forceNotification && isNotification }">
    <div class="modal-box relative bg-blue-custom-3">
      <label @click="forceNotification = false" class="btn btn-sm btn-circle absolute left-2 top-2">✕</label>
      <EnvelopeIcon class="w-24 h-24 mx-auto text-blue-custom-6" />
      <h3 class="font-bold text-lg mt-3 text-blue-custom-4">{{ __('Hello dear user') }}</h3>
      <p class="pt-4 pb-4 text-blue-custom-4">
        {{ __('You have new unread messages, click the Show Messages button to read the messages') }}
      </p>
      <div class="modal-action">
        <router-link class="btn btn-success btn-sm" :to="{ name: 'notification' }" @click="isNotification = false">{{
          __('Display messages') }}</router-link>
        <label class="btn btn-error btn-sm" @click="disableNotification">{{ __('Do not show this window') }}</label>
      </div>
    </div>
  </div>
  <div class="modal" id="modal-popup" :class="{ 'modal-open': user.privacy_confirm && popup }" v-if="popup && !isNotification">
    <div class="modal-box relative" :class="[popup.type !== 'notice' ? 'p-0 max-w-2xl w-auto' : 'max-w-xl']">
      <label @click="removePopup" class="btn btn-sm btn-circle absolute left-2 top-2 z-50">✕</label>
      <div class="w-full relative" v-if="popup.type === 'only_video' && popup?.embed_code?.includes('.mp4')">
        <video ref="popupVideo">
          <source :src="`${popup?.embed_code}#t=0.1`" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        <div class="romeo-embed-inner" @click="playVideo($event)"><span class="romeo-embed-play"><svg viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg" width="18" height="18">
              <path
                d="M7 6.134v11.732c0 .895 1.03 1.438 1.822.951l9.628-5.866c.733-.441.733-1.46 0-1.914L8.822 5.183C8.029 4.696 7 5.239 7 6.134z"
                fill="#FBFBFC"></path>
            </svg></span></div>
      </div>
      <div v-html="popup.embed_code" v-else-if="popup.type === 'only_video'"></div>
      <img :src="popup.image" alt="image" v-else-if="popup.type === 'only_image'">
      <div v-else-if="popup.type === 'notice'">
        <MegaphoneIcon class="w-20 h-20 md:w-24 md:h-24 mx-auto text-red-500" />
        <h3 class="font-bold text-lg mt-5">{{ popup.title }}</h3>
        <p class="py-2" v-html="popup.description"></p>
      </div>
    </div>
  </div>
  <div class="modal" :class="{ 'modal-open': application.show }">
    <div class="modal-box">
      <div v-html="application.description"></div>
      <div class="modal-action">
        <label class="btn btn-success btn-sm" @click="installApplication">{{ __('Installation') }}</label>
        <label class="btn btn-error btn-sm" @click="application.show = false">{{ __('Close') }}</label>
      </div>
    </div>
  </div>
  <LoadingAlert :show="progressDialog" />
  <button @click="showCart($event)" class="btn fixed bottom-11 left-11 btn-circle btn-warning hidden lg:flex" id="btn-cart"
    v-if="Auth.check() && isCartBtn">
    <span class="animate-ping absolute inline-flex w-10 h-10 rounded-full bg-warning opacity-75"></span>
    <ShoppingBagIcon class="w-6 h-6" />
    <div class="badge badge-error w-5 h-5 absolute -top-1 -right-1" v-if="user.cart?.count > 0">{{ user.cart?.count }}</div>
  </button>
  <BottomNavigation :user="user" v-if="isSidebar" />
  <Offline v-if="isOffline" :isSidebar="isSidebar" />
</template>
<script setup>
import Offline from "../layout/Offline.vue";
import BottomNavigation from "./layout/BottomNavigation.vue";
import { computed, provide, onMounted, onUpdated, ref, watch } from "vue";
import useProducts from "../../composables/shop/product";
import {
  HomeIcon, UserIcon, ListBulletIcon, VideoCameraIcon, PresentationChartLineIcon, ClipboardDocumentListIcon, ArrowTrendingUpIcon, ClockIcon, GiftIcon,PercentBadgeIcon,
  ArrowLeftStartOnRectangleIcon, EnvelopeIcon, GiftTopIcon, Cog6ToothIcon, ArrowRightStartOnRectangleIcon,BriefcaseIcon, MegaphoneIcon, ShoppingBagIcon,BugAntIcon, UserGroupIcon
} from '@heroicons/vue/24/outline';
import Auth from "../../composables/shop/auth";
import useHome from "../../composables/shop/home";
import { useRoute } from 'vue-router'
const user = Auth.user;
const route = useRoute();
const routeName = ref(null);
const isSidebar = Auth.isSidebar;
const forceNotification = ref(true);
const isNotification = Auth.isNotification;
const isCartBtn = ref(false);
const isOffline = ref(false);
const introductionBrand = ref(null);
const searchCategory = (e, attribute = '') => {
  let data = attribute ? (attribute === 'brand' ? brands.value : cars.value) : filterCategories.value;
  data = data.map(item => {
    item['hidden'] = !item.title.includes(e.target.value);
    return item;
  });
}
provide('isCartBtn', isCartBtn);
const { getCategories, brands } = useProducts();
const { popup, getPopup, removePopup, application, installApplication } = useHome();
watch(() => route.name, () => {
  isCartBtn.value = false;
  routeName.value = route.name.toString();
  if (Auth.check()) getPopup();
})
const showCart = (event) => {
  const sidebar = document.getElementById('left-sidebar');
  sidebar.previousElementSibling.classList.add('hidden');
  sidebar.classList.remove('hidden');
  event.currentTarget.classList.add('!hidden');
}
const disableNotification = () => {
  Auth.user.value.notification = 0;
  Auth.updateUser(false);
  isNotification.value = false;
}
const progressDialog = window.progressDialog;
const popupVideo = ref(null);
const playVideo = (e) => {
  e.currentTarget.classList.add('hidden');
  popupVideo.value.play();
  popupVideo.value.setAttribute('controls', 'controls');
}
const logout = () => Auth.logout();
const logo = window.nikran.logo;
const specialTitle = window.nikran.special_title;
const backgroundColor = window.backgroundColor
onMounted(() => {
  window.addEventListener('offline', () => isOffline.value = true);

  window.addEventListener('online', () => isOffline.value = false);
})
onUpdated(() => {
  const myDrawer = document.getElementById('my-drawer');
  document.querySelectorAll('.drawer-side ul li a, .btm-nav a').forEach(item => item.addEventListener('click', () => myDrawer.checked = false));
});
</script>